<template>
  <div>
    <v-layout row wrap align-center style="margin-top: 5%;">
      <v-flex class="text-xs-center">
    <v-card
      align-center
      max-width="500"
      class="mx-auto elogCardBg"
    >
      <v-list-item :style="customercolors">
        <v-list-item-content>
          <v-list-item-title class="headline">Auftrag nicht gefunden</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-card-text class="elogCardBg">
        Sehr geehrter Kunde <br>
        Leider konnte kein passender Auftrag gefunden werden oder der Link ist nicht mehr gültig.
        Verwenden Sie bitte nur zur Verfügung gestellte Links um Ihren Auftrag zu verfolgen.
      </v-card-text>

      <!--<v-card-actions>
        <v-btn
          text
          color="blue"
          class="forcetransform"
        >
          Contact Transporteur
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          text
          color="blue"
          class="forcetransform"
        >
          <i><font color="red">e</font></i>Log Kundenportal
        </v-btn>
      </v-card-actions>-->
    </v-card>
    </v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  computed: {
    customercolors: function () {
      return {
        'color': this.$store.state.ttlinkoptics.mainConstrastColor + '!important',
        'background-color': this.$store.state.ttlinkoptics.mainColor
      }
    }
  }
}
</script>
<style>
.forcetransform{
    text-transform: none !important;
  }
  .elogCardBg{
    background-color: #ffffff99 !important;
  }
</style>
